import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { imageDb } from '../../data/images/image-db';
import { ModalController, PopoverController } from '@ionic/angular';
import { EntryRepository } from '../../data/entry/entry.repository';
import { TopicRepository } from '../../data/topic/topic.repository';
import { PlanningRepository } from '../../data/planning/planning.repository';
import { AuthService } from '../../services/auth/auth.service';
import { AudioService } from '../../services/audio.service';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit {
  auth = inject(AuthService);
  audio = inject(AudioService);

  user?: any;

  constructor(private router: Router,
              private modalController: ModalController,
              private popoverController: PopoverController,
              private entryRepository: EntryRepository,
              private topicRepository: TopicRepository,
              private planningRepository: PlanningRepository) {
    (window as any)['accountComponent'] = this;

    // this.user = user(this.auth);
  }

  ngOnInit() {
  }

  async logout() {
    // localStorage.clear();
    await this.popoverController.dismiss();



    // this.firebaseSyncService.reset();
    // await this.auth.signOut();

    await this.auth.signOut();

    await this.router.navigate(['/login']);

    this.planningRepository.reset();
    this.entryRepository.reset();
    this.topicRepository.reset();

    // getRegistry().forEach(store => store.reset());
    await imageDb.images.clear();
  }
}
